import { create } from 'zustand';

import type { Plan } from '../entitlements/plans';

type PlanStore = {
  /** `null` means unresolved — the team query hasn't answered yet. Not "no plan". */
  plan: Plan | null;
  setPlan: (plan: Plan | null) => void;
};

const usePlanStore = create<PlanStore>((set) => ({
  plan: null,
  setPlan: (plan) => set({ plan }),
}));

export default usePlanStore;
